module.exports = __webpack_public_path__ + "static/media/blog_post_detail.2e187f44.png";